import {
  failIfValidOrNonExhaustive,
  ILoadable,
  IPYDatum,
  keyByMap,
  LoadableStatus,
} from '../../Utils';

export const getKey = (product_id: number, year: number) => `${product_id}-${year}`;

const convert =
  (inputStatus: ILoadable<IPYDatum[]>): ILoadable<Map<string, IPYDatum>> => {

  if (inputStatus.status === LoadableStatus.Initial) {
    return {status: LoadableStatus.Initial};
  } else if (inputStatus.status === LoadableStatus.Loading) {
    return {status: LoadableStatus.Loading};

  } else if (inputStatus.status === LoadableStatus.NotPresent) {
    return {status: LoadableStatus.NotPresent};

  } else if (inputStatus.status === LoadableStatus.Present) {
    const {data} = inputStatus;
    const output = keyByMap<string, IPYDatum>(({product_id, year}) => getKey(product_id, year))(data);
    return {status: LoadableStatus.Present, data: output};
  } else {
    failIfValidOrNonExhaustive(inputStatus, 'Invalid status type');
    // The following lines will never be executed:
    return {status: LoadableStatus.NotPresent};
  }
};

export default convert;
